var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.935 13.185-3.5-1.909a3.333 3.333 0 1 1 0-4.554l3.5-1.908q-.1-.393-.1-.815a3.333 3.333 0 1 1 .899 2.277l-3.5 1.909a3.34 3.34 0 0 1 0 1.629l3.5 1.908a3.333 3.333 0 1 1-.799 1.463M4 10.666a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333m9.167-5a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333m0 10a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"
  })));
};
export default SvgShare;